import React, { PureComponent } from 'react'
import {
  number, string, shape, func, bool,
} from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import Link from '@active/react-ui/Link'
import I18nMessage from '../I18nMessage'
import './Confirm.scss'
import { handleKeyboardEvent } from '../../../shared/utils/commonUtils'

class Confirm extends PureComponent {
  static propTypes = {
    timeToAction: number,
    handleComplete: func.isRequired,
    trackInfo: shape({
      eventName: string,
      widget: string,
      appPlatform: string,
      pageType: string,
      explicitName: string,
      subFeature: string,
      eventTracking: string,
    }),
    configureTrack: func.isRequired,
    countToClose: bool,
    i18n: func.isRequired,
  }

  static defaultProps = {
    timeToAction: 10,
    trackInfo: {},
    countToClose: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      counter: props.timeToAction,
    }
  }

  componentDidMount() {
    const { configureTrack, trackInfo } = this.props
    if (configureTrack && Object.keys(configureTrack).length > 0) {
      configureTrack(trackInfo)
    }
    this.counting = this.start()
  }

  componentWillUnmount() {
    clearInterval(this.counting)
  }

  start = () => setInterval(() => {
    const { handleComplete } = this.props
    const { counter } = this.state
    if (counter > 0) {
      this.setState({ counter: counter - 1 })
    } else {
      clearInterval(this.counting)
      handleComplete()
    }
  }, 1000)

  handleClick = e => {
    e.preventDefault()
    const { handleComplete } = this.props
    clearInterval(this.counting)
    handleComplete()
  }

  render() {
    const { countToClose, i18n } = this.props
    const { counter } = this.state

    const label = countToClose ? 'passport.counter.will.close.label' : 'passport.signup.createdAccount.counter'
    const ariaRole = countToClose ? 'button' : 'link'
    const ariaLabel = countToClose ? i18n('passport.common.text.clickHere.ariaLabel.close') : i18n('passport.common.text.clickHere.ariaLabel')

    return (
      <div className="passport__redirect">
        <p><I18nMessage id={label} params={{ 0: counter }} /></p>
        <p>
          <I18nMessage id="passport.common.text.or" />
          <Link
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            href="#"
            onClick={this.handleClick}
            className="mr-l-5"
            role={ariaRole}
            aria-label={ariaLabel}
            onKeyDown={handleKeyboardEvent(this.handleClick, 'Enter')}
          >
            <I18nMessage id="passport.common.text.clickHere" />
          </Link>
        </p>
      </div>
    )
  }
}

export default withI18n(Confirm)
